import { useNavigate } from "react-router-dom";
import Instagram from "../../assets/images/insta.svg"; //Instagram.png";
import Facebook from "../../assets/images/facebook.svg"; //Facebook.png";
import appstore from "../../assets/images/navbar/appstore.png";
import googleplay from "../../assets/images/navbar/googleplay.png";
// import LinkedIn from "../../assets/images/linkedin.svg"//LinkedIn.png";
import Youtube from "../../assets/images/youtube.svg"; //youtube.png";
import Xlogo from "../../assets/images/x.svg"; //LinkedIn.png";
//import Xlogo from "../../assets/images/Xlogo.png";
import TikTok from "../../assets/images/tiktok.svg"; //TikTok.png";
import linkedIn from "../../assets/images/linkedin.svg"; //TikTok.png";
import DownloadModal from "../../Components/Modals/DownloadModal";
import libasLogo from "../../assets/images/LibasLogo.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LocationModal from "../Modals/LocationModal";
import { Countriesdata } from "../../constants/CountriesData";
import { useSelector } from "react-redux";
function Footer() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [showLocation, setShowLocation] = useState(false);
  const { countryCode } = useSelector((store) => store.currency);
  const { currencies, selectedcurrency, currencydefault } = useSelector(
    (store) => store.currency
  );
  console.log(countryCode, "countryCode");

  return (
    <footer className=" footer text-center theFooter">
      <div className=" show-modal-download">
        {showLocation && (
          <LocationModal
            showLocation={showLocation}
            setShowLocation={setShowLocation}
          />
        )}
      </div>
      <div className=" show-modal-download">
        {show && <DownloadModal show={show} setShow={setShow} />}
      </div>
      <div className=" d-none d-lg-block">
        <div className=" justify-content-between  px-lg-5 px-2  d-none d-lg-flex pt-5 pb-4">
          <div
            className={` ${
              i18n.language == "en" ? "text-start" : "text-startAr"
            }`}
          >
            <div className="footer-title">
              {/* {t("footer41")} */}
              <img
                src={libasLogo}
                className="img-fluid mx-0 libasLogo invert-color"
                alt="Libas Logo"
              />
            </div>

            <div
              className="sub-tittle-footer"
              onClick={() =>
                navigate("/about-us") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/about-us"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                About Us
              </a>
              {t("footer43")}
            </div>

            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdKXzqMXVeM4CHUlMLPk4-iiBUq5rbhQQK0ivLIOuzmedxsBQ/viewform?embedded=true"
              className="sub-tittle-footer"
              target="_blank"
            >
              {i18n.language === "en" ? "Affiliate program" : "برنامج الشراكة"}
            </a>
            <div
              className="sub-tittle-footer"
              onClick={() =>
                navigate("/all-blogs") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/all-blogs"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                Blogs
              </a>
              {t("footer46")}
            </div>
          </div>

          <div
            className={` ${
              i18n.language == "en" ? "text-start" : "text-startAr"
            }`}
          >
            <div className="footer-title">{t("footer11")}</div>

            <div
              className="sub-tittle-footer"
              onClick={
                () => navigate("/terms-and-conditions/#RETURN")
                //&
                //window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/terms-and-conditions"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                Terms and Conditions
              </a>
              {t("footer12")}{" "}
            </div>

            <div
              className="sub-tittle-footer"
              onClick={
                () => navigate("/quality-control")
                //&
                //window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/quality-control"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                Quality Control
              </a>
              {t("footer13")}{" "}
            </div>
          </div>

          <div
            className={` ${
              i18n.language == "en" ? "text-start" : "text-startAr"
            }`}
          >
            <div className="footer-title">{t("footer21")}</div>

            <div
              className="sub-tittle-footer"
              onClick={() =>
                navigate("/how-to-sell") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/how-to-sell"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                How to Sell
              </a>{" "}
              {t("footer23")}{" "}
            </div>
          </div>
          <div
            className={` ${
              i18n.language == "en" ? "text-start" : "text-startAr"
            }`}
          >
            <div className="footer-title">{t("footer31")}</div>

            <div
              className="sub-tittle-footer"
              onClick={() =>
                navigate("/help-center") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              {t("footer32")}
            </div>
            <div
              className="sub-tittle-footer"
              onClick={() =>
                navigate("/contact-us") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              {t("footer45")}
            </div>
          </div>
          <div
            className={` ${
              i18n.language == "en" ? "text-center" : "text-center"
            }`}
          >
            <div className="footer-title" style={{ textAlign: "left" }}>
              {t("footer51")}
            </div>
            {/* showing only to solve internal link issues */}
            <a
              href="/all-products"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              SEO Directory
            </a>
            <div className="px-0  d-flex align-items-center">
              {/* <div className="justify-content-end d-flex btn-store2">
              <a href="https://youtu.be/lKWrbqZjr1I">
                <img src={youtube} className="img-fluid btn-store2 mx-0 " />
              </a>
            </div> */}
              <div>
                <a
                  href="https://www.instagram.com/thelibasapp"
                  aria-label="Visit Libas Luxury Instagram Profile"
                  target="_blank"
                >
                  <img
                    alt="Libas' Instagram page"
                    src={Instagram}
                    className={`img-fluid btn-store2 ${
                      i18n.language == "en" ? "ms-0" : "me-2"
                    }`}
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.facebook.com/thelibasapp"
                  aria-label="Visit Facebook Profile"
                  target="_blank"
                >
                  <img
                    alt="Libas' Facebook page"
                    src={Facebook}
                    className={`img-fluid btn-store2  ${
                      i18n.language == "en" ? "ms-2" : "me-2"
                    }`}
                  />
                </a>
              </div>
              {/* <div>
              <a href="https://www.linkedin.com/company/libasuae" aria-label="Visit Libas UAE LinkedIn Company Page">
                <img alt="Libas' LinkedIn page" src={LinkedIn} className="img-fluid btn-store2 mx-2" />
              </a>
            </div> */}
              <div>
                <a
                  href="https://www.tiktok.com/@thelibasapp"
                  aria-label="Visit Libas Luxury TikTok Profile"
                  target="_blank"
                >
                  <img
                    alt="Libas' TikTok page"
                    src={TikTok}
                    className={`img-fluid btn-store2 ${
                      i18n.language == "en" ? "ms-2" : "me-2"
                    }`}
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.twitter.com/thelibasapp"
                  aria-label="Visit Libas Luxury TikTok Profile"
                  target="_blank"
                >
                  <img
                    alt="Libas' TikTok page"
                    src={Xlogo}
                    className={`img-fluid btn-store2 ${
                      i18n.language == "en" ? "ms-2" : "me-2"
                    }`}
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.youtube.com/@thelibasapp"
                  aria-label="Visit Libas Luxury Youtube Profile"
                  target="_blank"
                >
                  <img
                    alt="Libas' Youtube page"
                    src={Youtube}
                    className={`img-fluid btn-store2 ${
                      i18n.language == "en" ? "ms-2" : "me-2"
                    }`}
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://www.linkedin.com/company/thelibasapp"
                  aria-label="Visit Libas Luxury LinkedIn Profile"
                  target="_blank"
                >
                  <img
                    alt="LinkedIn"
                    src={linkedIn}
                    className={`img-fluid btn-store2 ${
                      i18n.language == "en" ? "ms-2" : "me-2"
                    }`}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr className="hr-footer d-none d-lg-block mx-5" />
        <div className="d-flex  justify-content-between mx-5 pb-3">
          <button
            onClick={() => setShowLocation(true)}
            className="justify-content-between   px-2  d-none d-lg-flex pt-2 pb-2 selectedcountrytitle-footer bg-transparent d-flex align-items-center"
            type="button"
          >
            <div className="justify-content-between d-flex align-items-center w-100 ">
              <div className="d-flex align-items-center ">
                {Countriesdata?.filter(
                  (coun) => coun?.code == countryCode
                )?.map((con) =>
                  i18n.language == "en" ? (
                    <>
                      {con?.flag} <span className="px-2">{con?.name}</span>
                    </>
                  ) : (
                    <>
                      {con?.flag} <span className="px-2">{con?.nameAr}</span>
                    </>
                  )
                )}
                {"("}
                {currencies &&
                currencydefault &&
                (currencydefault || selectedcurrency)
                  ? selectedcurrency
                    ? currencies?.filter(
                        (curr) => curr?.id == selectedcurrency
                      )[0]?.name
                    : currencies?.filter(
                        (curr) => curr?.id == currencydefault
                      )[0]?.name
                  : ""}
                {")"}
                <div className="mx-1 pb-2">{" . "}</div>
                {i18n.language == "en" ? "English US" : "العربية"}
              </div>
            </div>
          </button>

          <div className="">
            <div
              className="sub-tittle-footer d-block "
              onClick={() =>
                navigate("/terms-and-conditions") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              <a
                href="/terms-and-conditions"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                Terms and Conditions
              </a>
              {i18n.language == "en" ? (
                <>
                  Terms & Conditions
                  {/* Terms <code className="code">&</code> Conditions */}
                </>
              ) : (
                t("footer15")
              )}
            </div>
          </div>
          <div className="  px-0">
            <div
              className="sub-tittle-footer d-block"
              onClick={() =>
                navigate("/privacy-policy") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            >
              {i18n.language == "en" ? (
                <>
                  Privacy Policy & Cookies{" "}
                  {/* Privacy Policy 
                    <code className="code">&</code>{" "}
                    Cookies{" "} */}
                </>
              ) : (
                t("footer24")
              )}
            </div>
          </div>
          <div className=" d-flex  px-0  d-none d-lg-flex">
            <div className={`${i18n.language == "en" ? " pe-3" : " ps-3"}`}>
              <a
                href="https://apps.apple.com/app/libas-uae/id1605637445"
                aria-label="Download Libas App on the Apple App Store"
              >
                <img
                  alt="Download the Libas app from apple store"
                  src={appstore}
                  className="img-fluid btn-store3"
                />
              </a>
            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.libas.libas&pli=1"
                aria-label="Download Libas UAE App on Google Play Store"
              >
                <img
                  alt="Download the Libas app from Google Play"
                  src={googleplay}
                  className="img-fluid btn-store3"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className=" px-lg-5 px-2  d-lg-none d-block">
        <div className="row  mx-0">
          <div className="col-12 px-0">
            <div
              className="accordion accordion-flush  pt-4"
              id="accordionFlushExample1"
            >
              <div className="accordion-item accordion-bgg border-0   border-0  border-0">
                <div className="accordion-header pt-2" id="flush-headingOne">
                  <button
                    className={`px-2 collapsed accordion-footerTitle accordion-bg ${
                      i18n.language == "en"
                        ? "accordion-button"
                        : "accordion-button accordion-buttonAr"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target=""
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    <img
                      src={libasLogo}
                      className="img-fluid mx-0 libasLogo invert-color"
                      alt="Libas Logo"
                    />
                  </button>
                </div>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample1"
                >
                  <div
                    className={`accordion-body   px-2 ${
                      i18n.language == "en" ? "text-start" : "text-startAr"
                    }`}
                  >
                    <div
                      className="subtxt-accordion-footer"
                      onClick={() =>
                        navigate("/about-us") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      <a
                        href="/about-us"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        About Us
                      </a>
                      {t("footer43")}
                    </div>

                    <div className="subtxt-accordion-footer">
                      <a
                        href="https://forms.gle/r4iW4ys258Q6vT7m9"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "white" }}
                        onClick={() =>
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "instant",
                          })
                        }
                      >
                        {t("Affiliate program")}
                      </a>
                    </div>

                    <div
                      to="/all-blogs"
                      className="subtxt-accordion-footer"
                      onClick={() =>
                        navigate("/all-blogs") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      <a
                        href="/all-blogs"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        Blogs
                      </a>
                      {t("footer46")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item accordion-bg border-0   border-0  border-0">
                <div className="accordion-header  pt-2" id="flush-headingTwo">
                  <button
                    className={`px-2 accordion-bg collapsed accordion-footerTitle accordion-bgg  ${
                      i18n.language == "en"
                        ? "accordion-button"
                        : "accordion-button accordion-buttonAr"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    {t("footer11")}
                  </button>
                </div>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div
                    className={`accordion-body   px-2 ${
                      i18n.language == "en" ? "text-start" : "text-startAr"
                    }`}
                  >
                    <div
                      className="subtxt-accordion-footer "
                      onClick={
                        () => navigate("/terms-and-conditions/#RETURN")
                        // &
                        // window.scrollTo({
                        //   top: 0,
                        //   left: 0,
                        //   behavior: "instant",
                        // })
                      }
                    >
                      <a
                        href="/terms-and-conditions"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        Terms and Conditions
                      </a>
                      {t("footer12")}{" "}
                    </div>
                    <div
                      className="subtxt-accordion-footer "
                      onClick={() =>
                        navigate("/quality-control") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      <a
                        href="/quality-control"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        Quality Control
                      </a>
                      {t("footer13")}{" "}
                    </div>
                    {/* <div
                      className="subtxt-accordion-footer "
                      onClick={() =>
                        navigate("/Shipping-Policy") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      {t("footer14")}{" "}
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="accordion-item accordion-bg border-0   border-0  border-0">
                <div className="accordion-header  pt-2" id="flush-headingThree">
                  <button
                    className={`px-2 accordion-bg collapsed accordion-footerTitle accordion-bg ${
                      i18n.language == "en"
                        ? "accordion-button"
                        : "accordion-button accordion-buttonAr"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    {t("footer21")}
                  </button>
                </div>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div
                    c
                    className={`accordion-body   px-2 ${
                      i18n.language == "en" ? "text-start" : "text-startAr"
                    }`}
                  >
                    {/* <a
                      href="https://libas.page.link/myStore"
                      className="subtxt-accordion-footer"
                    >
                     {t("footer22")}{" "}
                    </a> */}
                    <div
                      className="subtxt-accordion-footer"
                      onClick={() =>
                        navigate("/how-to-sell") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      <a
                        href="/how-to-sell"
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        How to Sell
                      </a>
                      {t("footer23")}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item accordion-bg border-0   border-0  border-0">
                <div className="accordion-header  pt-2" id="flush-headingFour">
                  <button
                    className={`px-2 accordion-bg collapsed accordion-footerTitle accordion-bg ${
                      i18n.language == "en"
                        ? "accordion-button"
                        : "accordion-button accordion-buttonAr"
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                  >
                    {t("footer31")}
                  </button>
                </div>
                <div
                  id="flush-collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headiheadingFourngThree"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div
                    className={`accordion-body   px-2 ${
                      i18n.language == "en" ? "text-start" : "text-startAr"
                    }`}
                  >
                    <div
                      className="subtxt-accordion-footer"
                      onClick={() =>
                        navigate("/help-center") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      {" "}
                      {t("footer32")}{" "}
                    </div>
                    <div
                      className="subtxt-accordion-footer"
                      onClick={() =>
                        navigate("/contact-us") &
                        window.scrollTo({
                          top: 0,
                          left: 0,
                          behavior: "instant",
                        })
                      }
                    >
                      {t("footer45")}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-4 pb-4 mx-0 px-0 ">
            <div className="col-12 px-0 d-flex ">
              <div className="px-0  d-flex align-items-center">
                {/* <div className="justify-content-end d-flex btn-store2">
                  <a href="https://youtu.be/lKWrbqZjr1I">
                    <img src={youtube} className="img-fluid btn-store2 mx-0 " />
                  </a>
                </div> */}
                <div>
                  <a
                    href="https://www.instagram.com/thelibasapp"
                    aria-label="Visit Libas Luxury Instagram Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' Instagram page"
                      src={Instagram}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.facebook.com/thelibasapp"
                    aria-label="Visit Facebook Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' Facebook page"
                      src={Facebook}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
                {/* <div>
                  <a href="https://www.linkedin.com/company/libasuae" aria-label="Visit Libas UAE LinkedIn Company Page">
                    <img alt="Libas' LinkedIn page" src={LinkedIn} className="img-fluid btn-store2" />
                  </a>
                </div> */}

                <div>
                  <a
                    href="https://www.tiktok.com/@thelibasapp"
                    aria-label="Visit Libas Luxury TikTok Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' TikTok page"
                      src={TikTok}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.twitter.com/thelibasapp"
                    aria-label="Visit Libas Luxury X Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' X page"
                      src={Xlogo}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.youtube.com/@thelibasapp"
                    aria-label="Visit Libas Luxury Youtube Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' Youtube page"
                      src={Youtube}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.linkedin.com/company/thelibasapp"
                    aria-label="Visit Libas Luxury LinkedIn Profile"
                    target="_blank"
                  >
                    <img
                      alt="Libas' LinkedIn page"
                      src={linkedIn}
                      className={`img-fluid btn-store2 ${
                        i18n.language == "en" ? "ms-2" : "me-2"
                      }`}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <hr className="hr-footer  " />

          <div className="row px-0">
            <button
              onClick={() => setShowLocation(true)}
              className="container      pt-2 pb-2 selectedcountrytitle-footer bg-transparent d-flex align-items-center"
              type="button"
            >
              <div className=" align-items-center w-100 ">
                <div className=" d-flex align-items-center ">
                  {Countriesdata.filter((coun) => coun.code == countryCode).map(
                    (con) =>
                      i18n.language == "en" ? (
                        <>
                          {con.flag} <span className="px-2">{con.name}</span>
                        </>
                      ) : (
                        <>
                          {con.flag} <span className="px-2">{con.nameAr}</span>
                        </>
                      )
                  )}
                  {"("}
                  {currencies && (currencydefault || selectedcurrency)
                    ? selectedcurrency
                      ? currencies.filter(
                          (curr) => curr.id == selectedcurrency
                        )[0].name
                      : currencies.filter(
                          (curr) => curr.id == currencydefault
                        )[0].name
                    : ""}
                  {")"}
                  <div className="mx-1 pb-2">{" . "}</div>
                  {i18n.language == "en" ? "English US" : "العربية"}
                </div>
              </div>
            </button>
          </div>

          {/* <div className='row'>
  <div className='col-12 d-flex justify-content-center'>
  <select id="disabledSelect" className="form-select select-location-acc"required>
            <option defaultValue>Lebanon - English US - $ - USD</option>
             </select>
  </div>
</div> */}
          <div className="row pt-4 pb-4 mx-0 px-0">
            <div className="col-12 d-flex  px-0">
              <div className="justify-content-between d-flex">
                <div className={`${i18n.language == "en" ? "pe-4" : "ps-4"}`}>
                  <div
                    className="code-accordion px-0"
                    onClick={() =>
                      navigate("/terms-and-conditions") &
                      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    }
                  >
                    <a
                      href="/terms-and-conditions"
                      style={{ display: "none" }}
                      aria-hidden="true"
                    >
                      Terms and Conditions
                    </a>
                    {i18n.language == "en" ? (
                      <>
                        Terms <code className="code">&</code> Conditions
                      </>
                    ) : (
                      t("footer15")
                    )}
                  </div>
                </div>

                <div>
                  <div
                    className="code-accordion px-0"
                    onClick={() =>
                      navigate("/privacy-policy") &
                      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    }
                  >
                    {i18n.language == "en" ? (
                      <>
                        Privacy Policy <code className="code-accordion">&</code>{" "}
                        Cookies{" "}
                      </>
                    ) : (
                      t("footer24")
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-0 px-0  pb-4 ">
            <div className="col-12 px-0 d-flex">
              <a
                href="https://apps.apple.com/app/libas-uae/id1605637445"
                aria-label="Download Libas App on the Apple App Store"
              >
                <img
                  alt="Download Libas App on the Apple App Store"
                  src={appstore}
                  className={`img-fluid btn-store3 ${
                    i18n.language == "en" ? " me-3" : " ms-3"
                  }`}
                />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.libas.libas&pli=1"
                aria-label="Download Libas UAE App on Google Play Store"
              >
                <img
                  alt="Download Libas UAE App on Google Play Store"
                  src={googleplay}
                  className="img-fluid btn-store3"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
